<div class="input-row">
  <span class="input-checkbox">
    <mat-checkbox
      [formControl]="formControl"
      class="whitespace-normal"
      required="complemento?.requerido"
      id="iccb-{{ complemento!.id }}">
    </mat-checkbox
    ><br />
    <span class="not-clickable" [ngClass]="{ 'disabled-label': disabled }">{{
      complemento?.requerido ? 'Obrigatório' : 'Opcional'
    }}</span>
  </span>
  <label for="iccb-{{ complemento!.id }}-input" class="checkbox-label">
    <p [ngClass]="{ 'disabled-label': disabled }">{{ complemento?.explicacao }}</p>
  </label>
</div>
